import { TaxRatesPage as TaxRatesPageView } from "@/components/TaxRatesPage";

export function TaxRatesPage() {
  return <TaxRatesPageView />;
}
